<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'BasicRouterView',
  components: {},

  props: {},

  data: function () {
    return {}
  },

  computed: {},

  watch: {},

  created () {},
  mounted () {},
  updated () {},
  destroyed () {},

  methods: {}
}
</script>
